var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folder-icon-box"},[_c('i',{class:{ 'UXicon-folder_minus': _vm.isOpen && _vm.item.type !== 'small',
        'UXicon-folder_plus' : !_vm.isOpen && _vm.item.type !== 'small',
        'UXicon-folder' : (_vm.item.type === 'small' || _vm.isFolder === 0) },on:{"click":function () { _vm.toggle(_vm.item) }}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69caba33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/agent/components/folderIcon.vue
// module id = null
// module chunks = 